import React, { ReactElement, useCallback } from 'react';
import styled from 'styled-components';
import { FileDropzone } from '~admin/view/components/ui/form/fields/file/file-dropzone.component';

interface Props<T> {
  onDrop: (formData: T) => void;
}

export const ImportJson = <T extends object>(props: Props<T>): ReactElement => {
  const onDropAccepted = useCallback(
    (acceptedFiles): void => {
      const fileReader = new FileReader();
      fileReader.onload = (): void => {
        try {
          props.onDrop(JSON.parse(fileReader.result as string));
        } catch (error) {
          // TODO(venkat): Show better error handling for invalid json.
        }
      };
      fileReader.readAsText(acceptedFiles[0]);
    },
    [props.onDrop],
  );

  return <StyledDropzone onDropAccepted={onDropAccepted} accept={'.json'} maxFiles={1} />;
};

const StyledDropzone = styled(FileDropzone)`
  margin-bottom: 40px;
  margin-right: auto;
`;



// WEBPACK FOOTER //
// ./view/components/ui/import-json.component.tsx